export default {
  svgPath: `
    <path fill-rule="evenodd" clip-rule="evenodd" d="M0.5 7H20.5V5H0.5V7ZM0.5 15H20.5V13H0.5V15Z"/>
  `,
  title: 'Menu',
  viewBox: '0 0 21 20',
};
